'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_CLASSES = {
  default: '',
  primary: 'loading-blue',
  'primary-orange': 'loading-orange'
};

var getTranslatedTitle = function getTranslatedTitle() {
  return _I18n2.default.fired && _I18n2.default.fired.ready ? _I18n2.default.text('salesUI.UILoading.title') : '';
};

var getClassName = function getClassName(className, grow) {
  return (0, _reactUtils.classNames)(className, 'uiLoading', { 'uiLoading-grow': grow });
};

var getStyle = function getStyle(minHeight, style) {
  return minHeight ? _extends({}, style, { minHeight: minHeight }) : style;
};

exports.default = _react2.default.createClass({
  displayName: 'UILoading',

  propTypes: {
    className: _react.PropTypes.string,
    color: _react.PropTypes.string,
    grow: _react.PropTypes.bool.isRequired,
    minHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    style: _react.PropTypes.object,
    title: (0, _createLazyPropType2.default)(_react.PropTypes.string).isRequired,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      grow: true,
      title: getTranslatedTitle,
      use: 'default'
    };
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        color = _props.color,
        grow = _props.grow,
        minHeight = _props.minHeight,
        style = _props.style,
        title = _props.title,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['className', 'color', 'grow', 'minHeight', 'style', 'title', 'use']);

    var dotColor = USE_CLASSES[use] || USE_CLASSES.default;
    return _react2.default.createElement(
      'div',
      _extends({
        className: getClassName(className, grow),
        'data-loading': true,
        style: getStyle(minHeight, style),
        title: (0, _lazyEval2.default)(title)
      }, rest),
      _react2.default.createElement('div', { className: 'uiLoadingDot dot-1 ' + dotColor, style: { color: color } }),
      _react2.default.createElement('div', { className: 'uiLoadingDot dot-2 ' + dotColor, style: { color: color } }),
      _react2.default.createElement('div', { className: 'uiLoadingDot dot-3 ' + dotColor, style: { color: color } })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/loading/UILoading.js
// module id = 160
// module chunks = 0